import { IStore } from '@boss/services';
import type { ButtonType } from '@boss/types/b2b-b2c';
import { getPixelPositionOffset, slugify } from '@boss/utils';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { faLocationDot } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Marker, OverlayView } from '@react-google-maps/api';

import StoreCard, { StoreCardTranslations } from '../../StoreCard';

type Props = {
  store: IStore;
  position: google.maps.LatLngLiteral;
  activeMarkerId: string | undefined;
  onSetActiveMarker: () => void;
  onClose: () => void;
  storeBasePath: string;
  storeCardVariant: 'primary' | 'secondary';
  storeCardCtaVariant?: 'link' | 'button';
  storeCardCtaButtonType?: ButtonType;
  translations: StoreCardTranslations;
};

const StoreMarker = ({
  store,
  position,
  activeMarkerId,
  onSetActiveMarker: setActiveMarker,
  onClose: handleClose,
  storeBasePath,
  storeCardVariant,
  storeCardCtaVariant,
  storeCardCtaButtonType,
  translations,
}: Props) => {
  return (
    <OverlayView
      getPixelPositionOffset={(width, height) =>
        getPixelPositionOffset({
          width,
          height,
          offsetY: 25,
          offsetX: -150,
        })
      }
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
      position={position}
    >
      <div>
        <Marker
          icon={{
            path: faLocationDot.icon[4] as string,
            fillColor: '#000',
            fillOpacity: 1,
            strokeWeight: 1,
            scale: 0.07,
            anchor: new google.maps.Point(16, 32),
          }}
          onClick={setActiveMarker}
          position={position}
        />

        {activeMarkerId && activeMarkerId === store?.id && (
          <div className="text-md relative z-40 min-w-[20rem] max-w-[40rem]">
            <div className="z-50 -mb-2 ml-2 text-center">
              <div className="z-50 inline-block w-16 overflow-visible">
                <div className="shadow-m h-11 w-11 origin-bottom-left rotate-45 transform bg-white" />
              </div>
            </div>
            <button className="absolute right-0 top-10 z-50 py-4 pr-6" onClick={handleClose}>
              <FontAwesomeIcon icon={faXmark} size="xl" />
            </button>
            <div className="relative z-40">
              <StoreCard
                compact
                ctaButtonType={storeCardCtaButtonType}
                ctaVariant={storeCardCtaVariant}
                href={`${storeBasePath}/${slugify(store.name)}`}
                message={store.customMessage}
                store={store}
                translations={translations}
                variant={storeCardVariant}
              />
            </div>
          </div>
        )}
      </div>
    </OverlayView>
  );
};

export default StoreMarker;
